<template>
  <div class="remote-component">


      <iframe class="iframe" :src="fullUrl" :name="name" ref="iframe" v-if="fullUrl"
              style="height:100%;z-index: 2;position: relative"></iframe>
      <div  style="height:100%;position: absolute;top:0;left:0;bottom: 0;right:0;display: flex;align-items: center;justify-content: center;flex-direction: column;min-height: 200px;">
        <van-loading
        >
          {{loadingText}}
        </van-loading>
      </div>


  </div>
</template>
<script>

import {getRandomString} from "./helper";
import {v4 as uuid} from "uuid";

export default {
  name: "RemoteComponent",
  props: {
    height: {
      type: String,
      required: false,
      default: '200px'
    },
    src: {
      type: String,
      required: false,
    },
    showLoading: {
      type: Boolean,
      required: false,
      default: true
    },
    loadingText: {
      type: String,
      required: false,
      default: '拼命加载中'
    },
    base: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
    },
    service: String,
    token: {
      type: String,
      required: false,
    },
    params: {
      type: Object,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: "micro-app",
    },
  },
  computed: {
    appName() {
      return this.name || this.service;
    },
    fullUrl() {
      let fullUrl = this.base + this.src;
      if (fullUrl.includes("?")) {
        fullUrl = fullUrl + "&_iframe=" + this.iframeId;
      } else {
        fullUrl = fullUrl + "?_iframe=" + this.iframeId;
      }
      return fullUrl
    },
  },
  mounted() {
    this.iframeId = uuid().replace(/-/g, '');
    this.wrapper = document.querySelector(".remote-component")
    window.addEventListener('message', this.messageHandler)
    const desc = `子应用${this.appName}：${this.fullUrl}`;
    console.log(desc);
    if (this.showLoading) {
      this.loading = true
    }
  },
  unmounted() {
    window.removeEventListener("message", this.messageHandler)
  },
  data() {
    return {
      loading: false,
      wrapper: null,
      iframeId: ""
    }
  },
  methods: {
    messageHandler(e) {
      if (e.data.iframeId == this.iframeId && e.data._domain === 'remote-component') {
        if (e.data._action == 'sizing') {
          if (this.$refs.iframe) {
            const cssHeight = this.wrapper.style.height;
            if (cssHeight) {
              //设置iframe高度
              this.$refs.iframe.style.height = cssHeight + "px";
            } else {
              const height = e.data.data.height;
              //设置iframe高度
              this.$refs.iframe.style.height = height + "px";
            }
          }
        } else {
          const data = e.data;

          if (data._type === 'return') {
            //处理子应用返回的数据
            this.$emit(`return_${data._id}`, data.data)

          } else if (data._type === 'emit') {
            this.$emit(data.data.name, data.data.params)
          } else {
            if (data.params != undefined) {
              this.$emit(data.name, data.params)
            } else {
              this.$emit(data.name)
            }
          }
        }
      }
    },
    getRandomString,
    // 调用子应用方法
    invoke(methodName, params) {
      const data = {
        _action: "invoke",
        service: this.service,
        methodName,
        params: JSON.stringify(params),
        _id: getRandomString(10),
      };

      this.$refs.iframe.contentWindow.postMessage(data, '*');


      console.log(
        `${this.appName} 调用了远程组件方法:window.invoke(${JSON.stringify(
          data
        )})`
      );
    },
    initComponent() {
      setTimeout(() => {
        this.loading = false
        this.$emit("mounted");
      });
    },
    /**
     * 监听子应用数据变化
     * @param {{name:string,params?:any}} e
     */
    handleDataChange(e) {
      const data = e.detail.data;

      if (data._type === 'return') {
        //处理子应用返回的数据
        this.$emit(`return_${data._id}`, data.data)

      } else if (data._type === 'emit') {
        this.$emit(data.data.name, data.data.params)
      } else {
        if (data.params != undefined) {
          this.$emit(data.name, data.params)
        } else {
          this.$emit(data.name)
        }
      }
    },
  },
};
</script>

<style lang="stylus">
micro-app {
  micro-app-body {
    min-width: auto !important;
  }
}


.remote-component {
  .remote-component-loading {
    min-height: 500px;
    height 100%
  }
}

.iframe {
  border 0 none;
  width 100%
}
</style>
